import colors from "../colors.js";

export default colors("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc");



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-scale-chromatic/src/categorical/Pastel2.js
// module id = 962
// module chunks = 0